export default __webpack_public_path__ + "static/8-a9d5b091ff53eb9e7b5b17074875d492.png";